import { createElement } from "react";
import { Presentation } from "lucide-react";
import type { NavItem } from "@/shell/navigation";
import { versaEnabled } from "./config";
import { VersaShortcutsNav } from "./VersaShortcutsNav";

/**
 * O item do Versa na sidebar, no grupo de visualizações. Ponto de encaixe:
 * `shell/navigation.ts` espalha esta lista (vazia com o Versa
 * desligado). `import type` de propósito — a navegação importa este
 * arquivo, e um import de valor de volta fecharia um ciclo.
 */
export const versaNavItems: NavItem[] = versaEnabled
  ? [
      {
        label: "Versa",
        icon: Presentation,
        scope: "company",
        group: "visualizacoes",
        href: id => `/empresas/${id}/versa`,
        // As rotas do Versa são de Técnico ou acima (o Visualizador só lê).
        requiresRole: "technician",
        // Os modelos que a pessoa fixou (atalho pessoal, 2026-10-30).
        renderAfter: context => createElement(VersaShortcutsNav, context),
      },
    ]
  : [];

/** O título da página no topo, pelo mesmo critério de `pageTitleForPath`. */
export function versaPageTitle(pathname: string, companyLabel: string): string | null {
  return versaEnabled && /\/versa(\/|$)/.test(pathname) ? `Versa · ${companyLabel}` : null;
}
